









import Component from 'vue-class-component'
import Vue from 'vue'
import FormInput from '@/components/lib/input/FormInput.vue'
import ActionButton from '@/components/lib/button/ActionButton.vue'
import RatingSelect  from '@/components/lib/select/RatingSelect.vue'
import SelectStatusFilter from '@/components/select/status/SelectStatusFilter.vue'
import {CompaniesListFilterModel, SelectModel, StatusType} from '@/services/types'
import {StoreActionTypes} from '@/store/types'

@Component({
    components: {
        FormInput,
        ActionButton,
        RatingSelect,
        SelectStatusFilter
    }
})
export default class GridFilter extends Vue{
    private componentClass = 'GridFilter'

    private searchInputValue = ''
    private statusSelectValue = 'null'

    private  statusSelectOptions: SelectModel [] = [
        {
            value: 'true',
            text: 'Активна'
        },
        {
            value: 'false',
            text: 'Деактивирована'
        }
    ]

    mounted() {
        this.searchInputValue = (this.$store.getters.getCompaniesFilterValue as CompaniesListFilterModel).search

        this.setStatusSelectedValue()
    }

    get getOutLineStatus() {
        const filtersValue = (this.$store.getters.getCompaniesFilterValue as CompaniesListFilterModel);
        return filtersValue.search.length == 0 && filtersValue.status == null ? true : false
    }

    setStatusSelectedValue() {
        let statusValue: StatusType | string;
        if ((this.$store.getters.getCompaniesFilterValue as CompaniesListFilterModel).status == null) {
            statusValue = 'null'
        }
        else {
            statusValue = (this.$store.getters.getCompaniesFilterValue as CompaniesListFilterModel).status
        }

        this.statusSelectValue = statusValue
    }

    handleSearchInputChangeEvent(text: string) {
        this.searchInputValue = text
    }

    handleStatusSelectChangeEvent(selected: string) {
        this.statusSelectValue = selected
    }

    getStatusSelectValue(): StatusType | null {
        if (this.statusSelectValue == 'null') {
            return null
        }
        else {
            return (this.statusSelectValue as StatusType)
        }
    }

    getCompaniesListFilterModel(): CompaniesListFilterModel {
        return {
            search: this.searchInputValue,
            status: this.getStatusSelectValue()
        }
    }

    getCompaniesListDefaultFilterModel(): CompaniesListFilterModel {
        return {
            search: '',
            status: null
        }
    }

    async okBtnListener() {
        this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST_FILTER, this.getCompaniesListFilterModel())
        await this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST)
    }

    async cancelBtnListener() {
        this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST_FILTER, this.getCompaniesListDefaultFilterModel())
        await this.$store.dispatch(StoreActionTypes.SET_COMPANIES_LIST)
        this.searchInputValue = (this.$store.getters.getCompaniesFilterValue as CompaniesListFilterModel).search;
        this.setStatusSelectedValue()
    }

    get showSetDefaultFiltersValueBtn(): boolean {
        return this.searchInputValue.length > 0 || this.statusSelectValue != 'null'
    }
}
